import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'FETCH_GROUP_MEMBERSHIP',
  'FETCH_GROUP_MEMBERSHIP_START',
  'FETCH_GROUP_MEMBERSHIP_SUCCESS',
  'FETCH_GROUP_MEMBERSHIP_ERROR',
  'REMOVE_GROUP_MEMBERSHIP',
  'REMOVE_GROUP_MEMBERSHIP_START',
  'REMOVE_GROUP_MEMBERSHIP_SUCCESS',
  'REMOVE_GROUP_MEMBERSHIP_ERROR',
]);
